import axios from "axios";
import configuration from "@/utils/configuration";

export const dashboardService = {

getOverallReport() {
  return axios.get(`${configuration.backUrl}/dashboard`, {
    withCredentials: true,
  });
},
getDashboardStudentList(params) {
  return axios.get(`${configuration.backUrl}/dashboard/student-lists`,{
    withCredentials: true,
    params:params
  });
},
getIncomeReport( params) {
  return axios.get(`${configuration.backUrl}/dashboard/income`, {
    withCredentials: true,
    params:params
  });
},
getMostIncomeCourse( params) {
  return axios.get(`${configuration.backUrl}/dashboard/income-proportion`, {
    withCredentials: true,
    params:params
  });
},
getCourseStatusReport( params) {
  return axios.get(`${configuration.backUrl}/dashboard/course-proportion`, {
    withCredentials: true,
    params:params
  });
},
getCourseMostStudent(params) {
  return axios.get(`${configuration.backUrl}/dashboard/course/statistics`, {
    withCredentials: true,
    params:params
  });
},
getExportReportOption() {
  return axios.get(`${configuration.backUrl}/dashboard/course/statistics/filter-option`, {
    withCredentials: true,
  });
},
getCourseExportReport(params) {
   return axios.get(`${configuration.backUrl}/dashboard/course/statistics/export`,{
      withCredentials: true,
      responseType: "blob",
      params: params,
      
    });
},
getExportStudentListByCourse(params) {
   return axios.get(`${configuration.backUrl}/dashboard/course/student/export`,{
      withCredentials: true,
      responseType: "blob",
      params: params,
      
    });
},
getCourseWithStatus( params) {
  return axios.get(`${configuration.backUrl}/dashboard/course`, {
    withCredentials: true,
    params:params
  });
},
}